import { includeGoodfillCommissionWithBasePrice } from "@goodfill/domain-math";
import { Currency, asAmount } from "@goodfill/domain-properties";
import { resolveTimeInForce } from "@goodfill/models-typescript";
import { PortfolioOrderTicket } from "../../../backendApi/amplifyGraphQl/PortfolioCustomOrderTicketList/PortfolioOrderTicket";
import { PricedBond } from "../../../bonds/PricedBond";
import { PresentedOrderTicket } from "./PresentedOrderTicket";
import { TIMEZONE_NEY_YORK } from "../../../../locale/timezone";

export const mapPortfolioOrderTicketToPresentedOrderTicket = (
  orderTicket: PortfolioOrderTicket,
  pricedBond: PricedBond,
): PresentedOrderTicket => {
  const loadedBondPrice = includeGoodfillCommissionWithBasePrice(
    orderTicket.bondPrice,
    { amount: orderTicket.faceAmount, currency: Currency.USD },
    orderTicket.direction,
  );

  return {
    id: orderTicket.id,
    bondId: pricedBond.bondIdCusip,
    bondTimezone: TIMEZONE_NEY_YORK,
    bondPaymentRank: pricedBond.paymentRank,
    bondCouponPayment: pricedBond.couponPayment,
    bondMaturityDate: pricedBond.maturityDate,
    ticker: pricedBond.issuerTicker,
    issuerName: pricedBond.issuerName,
    issuerId: pricedBond.issuerId,
    status: orderTicket.status,
    isImmediate: orderTicket.isImmediate,
    expiresAt: orderTicket.expiresAt,
    createdAt: orderTicket.createdAt,
    direction: orderTicket.direction,
    faceAmount: orderTicket.faceAmount,
    alreadyFilled: orderTicket.alreadyFilled,
    bondRatingMoodys: pricedBond.ratings.moodys,
    bondRatingSp: pricedBond.ratings.sp,
    loadedBondPrice,
    timeInForce: resolveTimeInForce(orderTicket),
    minimumFillSize: orderTicket.minimumFillSize,
    balanceAmount: asAmount(orderTicket.faceAmount.minus(orderTicket.alreadyFilled)),
  };
};
